import type { ComponentProps, ReactNode } from 'react';

import { cx } from '@mage-ui/styled-system/css';
import {
  input,
  inputDescription,
  inputError,
  inputLabel,
  inputRoot,
  inputSection,
  inputWrapper,
} from '@mage-ui/styled-system/recipes';
import { TextInput } from '@mantine/core';

export type InputTextProps = Omit<ComponentProps<'input'>, 'size'> & {
  name?: string;
  label?: string;
  description?: string;
  error?: string;
  classNames?: {
    root?: string;
    label?: string;
    description?: string;
    error?: string;
    wrapper?: string;
    input?: string;
    section?: string;
  };
  startSlot?: ReactNode;
  endSlot?: ReactNode;
  value?: string | number;
};

export const InputText = ({
  classNames,
  startSlot,
  endSlot,
  ...props
}: InputTextProps) => {
  return (
    <TextInput
      classNames={{
        root: cx(classNames?.root ?? inputRoot(), 'group'),
        label: classNames?.label ?? inputLabel(),
        required: classNames?.label ?? inputLabel(),
        description: classNames?.description ?? inputDescription(),
        error: classNames?.error ?? inputError(),
        wrapper: classNames?.wrapper ?? inputWrapper(),
        input: cx(classNames?.input ?? input(), 'peer'),
        section: classNames?.section ?? inputSection(),
      }}
      leftSection={startSlot}
      rightSection={endSlot}
      {...props}
    />
  );
};
